import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['content', 'tab'];
  static values = { active: String };

  connect() {
    if (!this.activeValue) {
      this.activeValue = 'personal';
    }
    this.showTab(this.activeValue);
  }

  switch(event) {
    const tabName = event.currentTarget.dataset.tab;
    this.showTab(tabName);
    this.activeValue = tabName;
  }

  showTab(tabName) {
    // Hide all tab contents
    this.contentTargets.forEach((content) => {
      content.classList.add('hidden');
    });

    // Remove active class from all tabs
    this.tabTargets.forEach((tab) => {
      tab.classList.remove('border-indigo-500', 'text-indigo-600');
      tab.classList.add('border-transparent', 'text-slate-500');
    });

    // Show selected tab content
    const activeContent = this.contentTargets.find((content) => content.id === `${tabName}-content`);
    if (activeContent) {
      activeContent.classList.remove('hidden');
    }

    // Add active class to selected tab
    const activeTab = this.tabTargets.find((tab) => tab.dataset.tab === tabName);
    if (activeTab) {
      activeTab.classList.remove('border-transparent', 'text-slate-500');
      activeTab.classList.add('border-indigo-500', 'text-indigo-600');
    }
  }
}
